@if (loading$ | async) {
<app-loading></app-loading>
}
<div class="header d-flex flex-row align-items-center justify-content-between">
    <img src="../../../../assets/images/psic-logo-black.svg" alt="psic-logo" class="pointerCursor" />
    <div
        [ngClass]="inputFocusFlag ? 'search-container-focused' : ''"
        class="search-container d-flex align-items-center"
        id="search-container"
    >
        <form class="w-100">
            <div class="search-box">
                <mat-select
                    class="search-by"
                    panelClass="dropdown-panel search-by-dropdown-panel"
                    disableOptionCentering
                    [(value)]="typeSelected"
                    placeholder="Search by"
                >
                    @for (type of (isThirdParty ? ['Policy number'] : ['Policy number', 'Name insured', 'Risk address']); track type) {
                    <mat-option [value]="type">
                        {{ type }}
                    </mat-option>
                    }
                </mat-select>

                <span class="divider"></span>

                <div class="input-wrapper" matAutocompleteOrigin #searchInputOrigin="matAutocompleteOrigin">
                    <input
                        type="text"
                        #searchElement
                        class="autocomplete-field"
                        [formControl]="policySearched"
                        (keyup)="docChanged(policySearched.value)"
                        [matAutocomplete]="auto"
                        [matAutocompleteConnectedTo]="searchInputOrigin"
                        (focus)="searchFocus(); formFocus = true"
                        (blur)="blurOut()"
                        (keydown.enter)="$event.preventDefault(); searchPolicy(policySearched.value || '')"
                        placeholder="Type here..."
                    />
                    <button type="button" class="btn-icon" (click)="onIconClick()">
                        @if (policySearched.value?.length > 0) {
                        <mat-icon [svgIcon]="'close-alt'"></mat-icon>
                        } @if (!policySearched.value?.length) {
                        <mat-icon [svgIcon]="'search'"></mat-icon>
                        }
                    </button>
                </div>
                <mat-autocomplete
                    id="ac-style"
                    class="ac-style"
                    #auto="matAutocomplete"
                    (optionSelected)="onPolicySelected($event)"
                >
                    @if (!isThirdParty) {
                    <div class="ac-spacer"></div>
                    @for (data of filteredDocs; track data; let i = $index) {
                    <mat-option
                        id="{{ 'option' + i }}"
                        #option
                        (mouseenter)="mouseEnter($event, i, getOptionValue(data, typeSelected, false))"
                        (mousemove)="positionSearchTooltip($event)"
                        (mousedown)="hideSearchTooltip()"
                        (mouseleave)="mouseLeave($event, i)"
                        [value]="data"
                    >
                        <mat-icon [svgIcon]="'search'"></mat-icon>
                        <span
                            class="option-text policy-search-tooltip-trigger"
                            [innerHTML]="getOptionValue(data, typeSelected) | highlight : policySearched.value"
                        ></span>
                    </mat-option>
                    } @if (filteredDocs.length === 0 && formFocus === true) {
                    <mat-option class="first" [disabled]="true" [value]="">
                        <mat-icon [svgIcon]="'search'"></mat-icon>
                        <span class="option-text">
                            {{ policySearched.value }} Not found. Check for typos and try again</span
                        >
                    </mat-option>
                    }
                    }
                </mat-autocomplete>
            </div>
        </form>
    </div>
    <div class="d-flex flex-row align-items-center psic-gap-4" (click)="onUserIconClick()">
        <!-- @if (!isProduction) {
            <select class="psic-br-4 psic-p-2" (change)="onThemeChange($event)" [(ngModel)]="defaultTheme" (click)="$event.stopPropagation()">
            @for (theme of themes; track theme) {
                <option [value]="theme.value">{{ theme.label }}</option>
            }
            </select>
        } -->
        @if (user$ | async; as user) {
        <span class="d-flex caption-bold dg_mg-60-color me-1"> {{ user['First_Name'] }} {{ user['Last_Name'] }} </span>
        }
        <mat-icon [svgIcon]="'user-circle'" class="mat-icon-32 p1-50-color pointerCursor"></mat-icon>
    </div>
</div>

<!-- Hamburger menu for page navigation during quote creation-->
@if (!isLandingPage || isProfileActivitiesRoute) {
<div class="side-nav hamburgerMenu hideSrollbar" [class.active]="true" [class.collapsed]="!showNav">
    <div class="d-flex flex-column align-items-start psic-gap-3">
        <ng-container>
            <div
                class="d-flex flex-row justify-content-between align-items-center psic-gap-3 nav-title-row psic-p-3 psic-pt-6 w-100 wh-100-background"
            >
                @if (showNav) {
                <h3 class="title">Policy 360°</h3>
                }
                <div (click)="toggleNav()">
                    @if (showNav) {
                    <mat-icon svgIcon="close" class="mat-icon-24 p1-50-color pointerCursor"></mat-icon>
                    } @else {
                    <mat-icon svgIcon="hamburger-menu" class="mat-icon-24 p1-50-color pointerCursor"></mat-icon>
                    }
                </div>
            </div>
            <mat-nav-list class="w-100">
                @for (menuItem of menuItemList; track menuItem) {
                <div
                    class="menuItem"
                    [class.no-highlight]="menuItem.name === 'Quick actions'"
                    [class.active]="selectedItem === menuItem.name && menuItem.name !== 'Quick actions'"
                    (click)="navigateToMenuItem(menuItem.name)"
                >
                    @if (menuItem.name === 'Quick actions') {
                    <div class="w-100">
                        <div class="d-flex align-items-center psic-gap-3 justify-content-between">
                            @if (showNav) {
                            <div class="d-flex flex-row align-items-center psic-gap-3">
                                <mat-icon [svgIcon]="'last-page'"></mat-icon>
                                <a class="caption">{{ menuItem.name }}</a>
                            </div>
                            @if (showActionsList) {
                            <mat-icon [svgIcon]="'chevron-up'"></mat-icon>
                            } @if (!showActionsList) {
                            <mat-icon [svgIcon]="'chevron-down'"></mat-icon>
                            } } @else {
                            <mat-icon
                                [svgIcon]="'last-page'"
                                psicTooltipPlacement="right"
                                psicTooltip="Quick actions"
                            ></mat-icon>
                            }
                        </div>
                        @if (showActionsList && showNav) {
                        <div class="psic-ml-7 psic-mt-3">
                            <div class="caption pointerCursor" (click)="sendThirdPartyLink(); $event.stopPropagation()">
                                Send third party link
                            </div>
                        </div>
                        }
                    </div>
                    } @else { @if (showNav) {
                    <mat-icon class="mat-icon-24" [svgIcon]="menuItem.image"></mat-icon>
                    <a class="caption">{{ menuItem.name }}</a>
                    } @else {
                    <mat-icon
                        class="mat-icon-24"
                        [svgIcon]="menuItem.image"
                        psicTooltipPlacement="right"
                        [psicTooltip]="menuItem.name"
                    ></mat-icon>
                    } }
                </div>
                }
            </mat-nav-list>
        </ng-container>
        <span class="separator w-100"></span>
        <div class="d-flex flex-column w-100 psic-gap-4">
            <div
                class="d-flex psic-p-3 flex-row justify-content-between align-items-center pointerCursor psic-gap-4"
                (click)="showDropdownFlag = !showDropdownFlag"
            >
                <div class="d-flex flex-row psic-gap-3">
                    <mat-icon
                        [svgIcon]="'agency-management'"
                        class="dg_mg-60-color"
                        psicTooltipPlacement="right"
                        [psicTooltip]="!showNav ? 'Policy snapshot' : ''"
                    ></mat-icon>
                    @if (showNav) {
                    <p class="alt-bold">Policy snapshot</p>
                    }
                </div>
                @if (showNav) { @if (showDropdownFlag) {
                <mat-icon [svgIcon]="'chevron-up'"></mat-icon>
                } @else {
                <mat-icon [svgIcon]="'chevron-down'"></mat-icon>
                } }
            </div>
            @if (showDropdownFlag || !showNav) {
            <mat-nav-list>
                @for (policyDetailItem of policyDetailList; track policyDetailItem) {
                <div
                    class="menuItem"
                    [class.no-highlight]="policyDetailItem.name === 'Quick actions'"
                    [class.active]="selectedItem === policyDetailItem.name && policyDetailItem.name !== 'Quick actions'"
                    (click)="navigateToPolicyDetail(policyDetailItem.name)"
                >
                    @if (policyDetailItem.name === 'Quick actions') {
                    <div class="w-100 d-flex flex-column psic-gap-3">
                        <div class="d-flex flex-row align-items-center psic-gap-3 justify-content-between">
                            @if (showNav) {
                            <div class="d-flex flex-row align-items-center psic-gap-3">
                                <mat-icon [svgIcon]="'last-page'"></mat-icon>
                                <a class="caption">{{ policyDetailItem.name }}</a>
                            </div>
                            @if (showPolicySnapActionsList) {
                            <mat-icon [svgIcon]="'chevron-up'"></mat-icon>
                            } @else {
                            <mat-icon [svgIcon]="'chevron-down'"></mat-icon>
                            } } @else {
                            <mat-icon
                                [svgIcon]="'last-page'"
                                psicTooltipPlacement="right"
                                psicTooltip="Quick actions"
                            ></mat-icon>
                            }
                        </div>
                        @if (showPolicySnapActionsList && showNav) {
                        <div class="d-flex flex-column psic-ml-7 psic-gap-6">
                            <div
                                class="caption pointerCursor"
                                (click)="generateLetterOfExperience(); $event.stopPropagation()"
                            >
                                Generate letter of experience
                            </div>
                            <div class="caption pointerCursor" (click)="sendPaymentLinkSMS()">Send Guest Payment Link</div>
                            <div class="caption pointerCursor" (click)="sendPortletLink()">Send Insured Payment link</div>
                        </div>
                        }
                    </div>
                    } @else {
                    <mat-icon
                        class="mat-icon-24"
                        [svgIcon]="policyDetailItem.image"
                        psicTooltipPlacement="right"
                        [psicTooltip]="!showNav ? policyDetailItem.name : ''"
                    ></mat-icon>
                    @if (showNav) {
                    <a class="caption">{{ policyDetailItem.name }}</a>
                    } }
                </div>
                }
            </mat-nav-list>
            }
        </div>
        <span class="separator w-100"></span>
        <div class="d-flex flex-column w-100 psic-gap-2 w-100">
            <div class="recent-policy-item" (click)="!showNav ? openRecentPolicies() : showRecentPoliciesFlag = !showRecentPoliciesFlag">
                <div class="d-flex flex-row psic-gap-3">
                    <mat-icon
                        [svgIcon]="'icon-clock-three'"
                        class="dg_mg-60-color"
                        psicTooltipPlacement="right"
                        [psicTooltip]="!showNav ? 'Recent policies' : ''"
                    ></mat-icon>
                    @if (showNav) {
                    <p class="alt-bold">Recent policies</p>
                    }
                </div>
                @if (showNav) {
                @if (showRecentPoliciesFlag) {
                <mat-icon [svgIcon]="'chevron-up'"></mat-icon>
                } @if (!showRecentPoliciesFlag) {
                <mat-icon [svgIcon]="'chevron-down'"></mat-icon>
                }
                }
            </div>
            @if (showRecentPoliciesFlag && showNav) {
            <mat-nav-list>
                @for (policy of recentPolicies$ | async; track policy) {
                <div
                    class="recent-policy-item border-bottom"
                    (click)="selectRecentPolicy(policy.policyNumber)"
                >
                    <p class="caption-bold">{{ policy.lineOfBusiness }}</p>
                    <p class="disclaimer-bold p1-50-color disclaimer-bold-underline">
                        {{ policy.policyNumber }}
                    </p>
                </div>
                } @if ((recentPolicies$ | async)?.length === 0) {
                <div class="menuItem">
                    <span class="caption">No recent policies</span>
                </div>
                }
            </mat-nav-list>
            }
        </div>
    </div>
</div>
}

<div class="profile-nav" [class.active]="showProfileNav">
    @if (!isThirdParty) {
    <nav aria-label="profile-nav-item" class="wh-100-background">
        <ul class="d-flex flex-column psic-p-0 psic-m-0">
            <li
                (click)="logout()"
                class="side-nav-item caption d-flex flex-row align-items-center psic-gap-2 psic-py-4"
            >
                <mat-icon [svgIcon]="'log-out'" alt="sign-out"></mat-icon>
                Sign Out
            </li>
        </ul>
    </nav>
    }
    <div class="backdrop" (click)="showProfileNav = false; showNav = false"></div>
</div>
